//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/BaseCreator.js";
import "../no/ObjectSelector.js";
import "../no/ObjectTypeSelector.js";
import "../no/ObjectSelector.js";
import "../no/ObjectTypeSelector.js";
let d=[[[0,"Author",1,0],[0,"BcurveTol",1,0],[0,"Company",1,0],[0,"Csys",1,"CoordinateSystem",0],[0,"DrawingList",1,0],[0,"ExportDrawings",1,0],[0,"ExportFrom",1,0],[0,"ExportModelData",1,0],[1,"ExportSelectionBlock",0,"ObjectSelector",0],[0,"FileSaveFlag",1,0],[0,"FlattenAssembly",1,0],[0,"IdenticalPointResolution",1,0],[0,"InputFile",1,0],[0,"Jama",1,0],[0,"LayerMask",1,0],[0,"MapCrossHatchTo",1,0],[0,"MapRevolvedFacesTo",1,0],[0,"MapTabCylToBSurf",1,0],[0,"MaxLineThickness",1,0],[0,"MaxThreeDMdlSpace",1,0],[1,"ObjectTypes",0,"ObjectTypeSelector",0],[0,"ReceiverID",1,0],[0,"ReferenceType",1,0],[0,"SettingsFile",1,0],[0,"StartSectionFile",1,0],[0,"SysDefidenticalPointResolution",1,0],[0,"SysDefmaxThreeDMdlSpace",1,0],[0,"UseStartSectionFile",1,0],[0,"ViewList",1,0]],[[["filename"],"SaveSettings",{},1,0],[["objects"],"SetDrawingArray",{},1,0]],[]];
SPLM.IgesCreator = class extends SPLM.BaseCreator{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.IgesCreator";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.IgesCreator.ExportFromOption = Object.freeze({
    "DisplayPart" : "DisplayPart", "ExistingPart" : "ExistingPart"});

SPLM.IgesCreator.CsysrefEnum = Object.freeze({
    "Absolute" : "Absolute", "Wcs" : "Wcs", "SpecifiedCsys" : "SpecifiedCsys"});

SPLM.IgesCreator.MapRevolvedFacesOption = Object.freeze({
    "BSurfaces" : "BSurfaces", "SurfaceOfRevolution" : "SurfaceOfRevolution"});

SPLM.IgesCreator.CrossHatchMapEnum = Object.freeze({
    "SectionArea" : "SectionArea", "CopiousData" : "CopiousData"});

export default SPLM;